import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TSuggest } from 'feature/registration/types'

import {
  TEditAppealRequest,
  TEditAppealTimeSlot,
  TEditAppealProduct,
} from '../type'

const initialState: TEditAppealRequest = {
  uid: 0,
  orderId: '',
  products: [],
  location: undefined,
  timeSlots: [],
}
//  слайс для методов редактируемой заявки
const EditableAppealSlice = createSlice({
  name: 'EditableAppealSlice',
  initialState,
  reducers: {
    // добавление информации о заявки в state
    setAppeal: (state, action: PayloadAction<TEditAppealRequest>) => {
      const { uid, orderId, products, location, timeSlots } = action.payload
      state.uid = uid
      state.orderId = orderId
      state.products = products
      state.location = location
      state.timeSlots = timeSlots
    },
    // задать значение локации
    setLocation: (state, action: PayloadAction<TSuggest>) => {
      state.location = action.payload
    },
    // задать значение тайслота
    setTimeSlot: (state, action: PayloadAction<TEditAppealTimeSlot[]>) => {
      state.timeSlots = action.payload
    },
    // задать значение продуктов заявки
    setProducts: (state, action: PayloadAction<TEditAppealProduct[]>) => {
      state.products = action.payload
    },
    // редактирование параметов заказа
    editProductParams: (state, action: PayloadAction<TEditAppealProduct>) => {
      const { id, parameters } = action.payload
      if (state.products)
        state.products = state.products.map(product => {
          if (product.id === id) {
            return {
              ...product,
              parameters: parameters,
            }
          }
          return product
        })
    },
  },
})

export const { actions, reducer } = EditableAppealSlice
